import { Navigate } from "react-router-dom";

export default function Login() {
  return <Navigate to="/welcome?auth=signin" replace />;
}
